var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',[_vm._v(_vm._s(_vm.contact.first_name)+" - "+_vm._s(_vm.contact.last_name))]),_c('br'),_vm._v(" "),(_vm.$root.canManage())?_c('a',{attrs:{"href":("mailto:" + (_vm.contact.email))}},[_vm._v(_vm._s(_vm.contact.email))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11823631","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactEntity.vue
// module id = 944
// module chunks = 1